import { IEditCategoryContext } from './editCategoryContext';

export enum EditCategoryActionTypes {
	REFETCH_DATA = 'REFETCH_DATA',
	SET_ALL_DATA = 'SET_ALL_DATA',
	CHANGE_LOADER_STATUS = 'CHANGE_LOADER_STATUS',
	SET_FILE_ID = 'SET_FILE_ID',
	DELETE_PHOTO = 'DELETE_PHOTO',
	SET_FETCHED_CUSTOMERS = 'SET_FETCHED_CUSTOMERS',
	SET_ID_CUSTOMER = 'SET_ID_CUSTOMER',
	SET_FETCHED_RESTAURANTS = 'SET_FETCHED_RESTAURANTS',
	SET_IDS_RESTAURANT = 'SET_IDS_RESTAURANT',
	CHANGE_NAME_OF_CATEGORY = 'CHANGE_NAME_OF_CATEGORY',
	SET_CATEGORY_TYPE = 'SET_CATEGORY_TYPE',
	TOGGLE_IS_RESTRICTED = 'TOGGLE_IS_RESTRICTED',
	TOGGLE_HAS_SCHEDULE_PRIORITY = 'TOGGLE_HAS_SCHEDULE_PRIORITY',
	CHANGE_ACTIVATION_SCHEDULE = 'CHANGE_ACTIVATION_SCHEDULE',
	CHANGE_DEACTIVATION_SCHEDULE = 'CHANGE_DEACTIVATION_SCHEDULE',
	SET_DEFAULT_CUSTOMER_LANGUAGE = 'SET_DEFAULT_CUSTOMER_LANGUAGE',
	SET_TRANSLATION_TAB = 'SET_TRANSLATION_TAB',
	CHANGE_TRANSLATION = 'CHANGE_TRANSLATION',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
}

interface IRefetchData {
	type: EditCategoryActionTypes.REFETCH_DATA;
	payload: {
		needRefetchData: IEditCategoryContext['needRefetchData'];
	};
}

interface ISetAllData {
	type: EditCategoryActionTypes.SET_ALL_DATA;
	payload: {
		filePath: IEditCategoryContext['filePath'];
		categoryID: IEditCategoryContext['categoryID'];
		initialIDSelectedCustomer: IEditCategoryContext['initialIDSelectedCustomer'];
		initialIDsSelectedRestaurant: IEditCategoryContext['initialIDsSelectedRestaurant'];
		nameOfCategory: IEditCategoryContext['nameOfCategory'];
		categoryType: IEditCategoryContext['categoryType'];
		isRestricted: IEditCategoryContext['isRestricted'];
		hasSchedulePriority: IEditCategoryContext['hasSchedulePriority'];
		activationSchedule: IEditCategoryContext['activationSchedule'];
		deactivationSchedule: IEditCategoryContext['deactivationSchedule'];
		translations: IEditCategoryContext['translations'];
	};
}

interface IChangeLoaderStatus {
	type: EditCategoryActionTypes.CHANGE_LOADER_STATUS;
	payload: {
		isLoading: IEditCategoryContext['isLoading'];
	};
}

interface ISetFileId {
	type: EditCategoryActionTypes.SET_FILE_ID;
	payload: {
		fileId: IEditCategoryContext['fileId'];
	};
}

interface IDeletePhoto {
	type: EditCategoryActionTypes.DELETE_PHOTO;
}

interface ISetFetchedCustomers {
	type: EditCategoryActionTypes.SET_FETCHED_CUSTOMERS;
	payload: {
		fetchedCustomers: IEditCategoryContext['fetchedCustomers'];
	};
}

interface ISetIDCustomer {
	type: EditCategoryActionTypes.SET_ID_CUSTOMER;
	payload: {
		IDSelectedCustomer: IEditCategoryContext['IDSelectedCustomer'];
	};
}

interface ISetFetchedRestaurants {
	type: EditCategoryActionTypes.SET_FETCHED_RESTAURANTS;
	payload: {
		fetchedRestaurants: IEditCategoryContext['fetchedRestaurants'];
	};
}

interface ISetIDsRestaurant {
	type: EditCategoryActionTypes.SET_IDS_RESTAURANT;
	payload: {
		IDsSelectedRestaurant: IEditCategoryContext['IDsSelectedRestaurant'];
	};
}

interface IChangeNameOfCategory {
	type: EditCategoryActionTypes.CHANGE_NAME_OF_CATEGORY;
	payload: {
		nameOfCategory: IEditCategoryContext['nameOfCategory'];
	};
}

interface ISetCategoryType {
	type: EditCategoryActionTypes.SET_CATEGORY_TYPE;
	payload: {
		categoryType: IEditCategoryContext['categoryType'];
	};
}

interface IToggleIsRestricted {
	type: EditCategoryActionTypes.TOGGLE_IS_RESTRICTED;
}

interface IToggleHasSchedulePriority {
	type: EditCategoryActionTypes.TOGGLE_HAS_SCHEDULE_PRIORITY;
}

interface IChangeActivationSchedule {
	type: EditCategoryActionTypes.CHANGE_ACTIVATION_SCHEDULE;
	payload: {
		activationSchedule: IEditCategoryContext['activationSchedule'];
	};
}

interface IChangeDeactivationSchedule {
	type: EditCategoryActionTypes.CHANGE_DEACTIVATION_SCHEDULE;
	payload: {
		deactivationSchedule: IEditCategoryContext['deactivationSchedule'];
	};
}

interface ISetDefaultCustomerLanguage {
	type: EditCategoryActionTypes.SET_DEFAULT_CUSTOMER_LANGUAGE;
	payload: {
		defaultCustomerLanguage: IEditCategoryContext['defaultCustomerLanguage'];
	};
}

interface ISetTranslationTab {
	type: EditCategoryActionTypes.SET_TRANSLATION_TAB;
	payload: {
		selectedTranslationTab: IEditCategoryContext['selectedTranslationTab'];
	};
}

interface IChangeTranslation {
	type: EditCategoryActionTypes.CHANGE_TRANSLATION;
	payload: {
		translations: IEditCategoryContext['translations'];
	};
}

interface ISetDataForSubmit {
	type: EditCategoryActionTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: IEditCategoryContext['dataForSubmit'];
	};
}

interface IChangeTypeOfModalWindow {
	type: EditCategoryActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: IEditCategoryContext['typeOfModalWindow'];
	};
}

export type TEditCategoryAction =
	| IRefetchData
	| ISetAllData
	| IChangeLoaderStatus
	| ISetFileId
	| IDeletePhoto
	| ISetFetchedCustomers
	| ISetIDCustomer
	| ISetFetchedRestaurants
	| ISetIDsRestaurant
	| IChangeNameOfCategory
	| ISetCategoryType
	| IToggleIsRestricted
	| IToggleHasSchedulePriority
	| IChangeActivationSchedule
	| IChangeDeactivationSchedule
	| ISetDefaultCustomerLanguage
	| ISetTranslationTab
	| IChangeTranslation
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow;
